import { DocumentNode, useQuery } from '@apollo/client';
import { chartFetchTimestampsVar } from 'utility/cache/ui';

export function useTimedRefetchQuery<TData>(
  query: DocumentNode,
  title: string,
  manualRefresh: boolean,
  timedRefreshMilliseconds: number | null
) {
  const timestamps = chartFetchTimestampsVar();
  const lastFetchedAt = timestamps[title] ?? null;

  const now = Date.now();
  const timeSinceLast = lastFetchedAt ? now - lastFetchedAt : null;

  const shouldRefetch =
    !manualRefresh &&
    (timedRefreshMilliseconds == null ||
      timeSinceLast == null ||
      timeSinceLast > timedRefreshMilliseconds);

  const fetchPolicy = shouldRefetch ? 'network-only' : 'cache-first';

  const { data, loading, refetch, networkStatus } = useQuery<TData>(query, {
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      chartFetchTimestampsVar({
        ...chartFetchTimestampsVar(),
        [title]: Date.now(),
      });
    },
  });

  return { data, loading, refetch, networkStatus };
}
